// import React, { useState } from "react";
// import createInstance from "../../../api/axiosinstance";
// import { toast } from "react-toastify";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

// const InterviewerJoining = () => {
//   const aiDishaApi = createInstance("DISHA");
//   const [loading, setLoading] = useState(false);

//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     mobile: "",
//     Date_of_birth: "",
//     address: { H_No: "", city: "", state: "", country: "" },
//     password: "",
//     confirm_password: "",
//     role: "TP-Interviewer",
//     status: "InActive",
//     activation_status: "Pending",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (["H_No", "city", "state", "country"].includes(name)) {
//       setFormData({
//         ...formData,
//         address: { ...formData.address, [name]: value },
//       });
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };

//   const validateForm = () => {
//     const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
//     const phoneRegex = /^[0-9]{10}$/;

//     if (!formData.name.trim()) return "Name is required";
//     if (!formData.email || !emailRegex.test(formData.email))
//       return "Enter a valid email";
//     if (!formData.mobile || !phoneRegex.test(formData.mobile))
//       return "Enter a valid 10-digit mobile number";
//     if (!formData.Date_of_birth) return "Date of birth is required";
//     if (!formData.address.H_No.trim()) return "House No. is required";
//     if (!formData.address.city.trim()) return "City is required";
//     if (!formData.address.state.trim()) return "State is required";
//     if (!formData.address.country.trim()) return "Country is required";
//     if (!formData.password) return "Password is required";
//     if (formData.password.length < 6)
//       return "Password must be at least 6 characters";
//     if (formData.password !== formData.confirm_password)
//       return "Passwords do not match";

//     return null;
//   };

//   const clearForm = () => {
//     setFormData({
//       name: "",
//       email: "",
//       mobile: "",
//       Date_of_birth: "",
//       address: { H_No: "", city: "", state: "", country: "" },
//       password: "",
//       confirm_password: "",
//       role: "TP-Interviewer",
//       status: "InActive",
//       activation_status: "Pending",
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationError = validateForm();
//     if (validationError) {
//       toast.error(validationError);
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await aiDishaApi.post("/interviewer_register", formData);
//       toast.success(response.data.message || "Registration successful!");
//       clearForm();
//     } catch (error) {
//       console.error(error);
//       toast.error(
//         error.response?.data?.detail || "Error while registering interviewer"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container mt-4" style={{ maxWidth: "700px" }}>
//       <div
//         className="card"
//         style={{ backgroundColor: "white", borderRadius: "8px" }}
//       >
//         <div
//           className="card-header"
//           style={{
//             backgroundColor: "#033538",
//             color: "white",
//             borderRadius: "8px 8px 0 0",
//           }}
//         >
//           <h5 className="mb-0" style={{ fontFamily: "poppins" }}>
//             Interviewer Registration
//           </h5>
//         </div>

//         <form onSubmit={handleSubmit}>
//           <div className="card-body">
//             {/* Password */}
//             <div className="row">
//               <div className="col-md-6 mb-3 position-relative">
//                 <label className="form-label" style={{ color: "#033538" }}>
//                   Password *
//                 </label>
//                 <div className="input-group">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     className="form-control form-control-sm"
//                     name="password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     required
//                   />
//                   <span
//                     className="input-group-text"
//                     style={{
//                       cursor: "pointer",
//                       backgroundColor: "white",
//                       borderLeft: "none",
//                     }}
//                     onClick={() => setShowPassword(!showPassword)}
//                   >
//                     <FontAwesomeIcon
//                       icon={showPassword ? faEyeSlash : faEye}
//                       color="#033538"
//                     />
//                   </span>
//                 </div>
//               </div>

//               {/* Confirm Password */}
//               <div className="col-md-6 mb-3 position-relative">
//                 <label className="form-label" style={{ color: "#033538" }}>
//                   Confirm Password *
//                 </label>
//                 <div className="input-group">
//                   <input
//                     type={showConfirmPassword ? "text" : "password"}
//                     className="form-control form-control-sm"
//                     name="confirm_password"
//                     value={formData.confirm_password}
//                     onChange={handleChange}
//                     required
//                   />
//                   <span
//                     className="input-group-text"
//                     style={{
//                       cursor: "pointer",
//                       backgroundColor: "white",
//                       borderLeft: "none",
//                     }}
//                     onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                   >
//                     <FontAwesomeIcon
//                       icon={showConfirmPassword ? faEyeSlash : faEye}
//                       color="#033538"
//                     />
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="card-footer d-flex justify-content-end border-0">
//             <button
//               type="button"
//               className="btn btn-outline-secondary btn-sm me-2"
//               onClick={clearForm}
//             >
//               Clear
//             </button>
//             <button
//               type="submit"
//               className="btn btn-sm"
//               style={{ backgroundColor: "#033538", color: "white" }}
//               disabled={loading}
//             >
//               {loading ? "Registering..." : "Submit"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default InterviewerJoining;



























// import React, { useState } from "react";
// import createInstance from "../../../api/axiosinstance.js";
// import { toast } from "react-toastify";
// import { useThemeMode } from "../../Themes/ThemeContextTemp.js";
// import { FilePresent, Height } from "@mui/icons-material";
// import { Form } from "react-router-dom";
// import { height } from "@mui/system";

// const InterviewerJoining = ({ isOpen, onClose, fetchTableData }) => {
//   const aiDishaApi = createInstance("DISHA");
//   const { COLORS } = useThemeMode();
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const [fullName, setFullName] = useState("");
//   const [officialEmail, setOfficialEmail] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [address, setAddress] = useState("");
//   const [department, setDepartment] = useState("");
//   const [designation, setDesignation] = useState("");
//   const [skills, setSkills] = useState("");
//   const [additionalSkills, setAdditionalSkills] = useState("");
//   const [functionalArea, setFunctionalArea] = useState("");
//   const [additionalFunctionalArea, setAdditionalFunctionalArea] = useState("");
//   const [category, setCategory] = useState("");
//   const [panel, setPanel] = useState("");
//   const [activation, setActivation] = useState(false);

//   const organizationId = window.sessionStorage.getItem("organizationId") || "";

//   const categoryOptions = ["Technical", "HR", "Managerial"];
//   const panelOptions = ["Technical", "HR", "Managerial"];
//   const functionalAreaOptions = [
//     "Software Development",
//     "Quality Assurance",
//     "DevOps",
//     "Data Science",
//     "HR",
//     "Management",
//   ];

//   const clearForm = () => {
//     setFullName("");
//     setOfficialEmail("");
//     setMobileNumber("");
//     setAddress("");
//     setDepartment("");
//     setDesignation("");
//     setSkills("");
//     setAdditionalSkills("");
//     setFunctionalArea("");
//     setAdditionalFunctionalArea("");
//     setCategory("");
//     setPanel("");
//     setActivation(false);
//   };

//   const validateForm = () => {
//     if (!fullName.trim()) { toast.error("Full name cannot be empty"); return false; }
//     const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
//     if (!officialEmail.trim() || !emailRegex.test(officialEmail)) { toast.error("Enter a valid email"); return false; }
//     const phoneRegex = /^[0-9]{10}$/;
//     if (!mobileNumber.trim() || !phoneRegex.test(mobileNumber)) { toast.error("Enter a valid 10-digit mobile number"); return false; }
//     if (!address.trim()) { toast.error("Address cannot be empty"); return false; }
//     if (!department.trim()) { toast.error("Department cannot be empty"); return false; }
//     if (!designation.trim()) { toast.error("Designation cannot be empty"); return false; }
//     if (!category) { toast.error("Category cannot be empty"); return false; }
//     if (!panel) { toast.error("Panel cannot be empty"); return false; }
//     if (category === "Technical" && !skills.trim()) { toast.error("Skills are required for Technical category"); return false; }
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;
//     setIsSubmitting(true);
//     try {
//       const skillsArray = skills ? skills.split(",").map((s) => s.trim()).filter(Boolean) : [];
//       const additionalSkillsArray = additionalSkills ? additionalSkills.split(",").map((s) => s.trim()).filter(Boolean) : [];
//       const additionalFunctionalAreaArray = additionalFunctionalArea ? additionalFunctionalArea.split(",").map((s) => s.trim()).filter(Boolean) : [];

//       const response = await aiDishaApi.post(
//         "/org-user-Register",
//         {
//           organization_id: organizationId,
//           full_name: fullName,
//           official_email_id: officialEmail,
//           mobile_number: mobileNumber,
//           address: address,
//           department: department,
//           designation: designation,
//           skills: skillsArray,
//           additional_skills: additionalSkillsArray,
//           additional_functional_area: additionalFunctionalAreaArray,
//           activation: activation,
//         },
//         {
//           params: {
//             functional_area: functionalArea || undefined,
//             category: category,
//             panel: panel || undefined,
//           },
//         }
//       );

//       if (response.status === 200) {
//         toast.success(response.data.message || "User created successfully and activation mail sent!");
//         clearForm();
//         if (onClose) onClose();
//         if (fetchTableData) fetchTableData();
//       }
//     } catch (error) {
//       console.error("Error registering user:", error);
//       toast.error(error.response?.data?.detail || "Something went wrong");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <>
//     {isOpen && (
//     <>
//     <div
//       // className={`modal fade ${isOpen ? "show" : ""}`}
//       // className= "modal fade show d-block"
//       // tabIndex="-1"
//       // style={{ display: isOpen ? "block" : "none" }}
//       className="modal show d-block" tabIndex="-1"
//     >
//       <div className="modal-dialog modal-lg modal-dialog-centered">
//         <div className="modal-content" style={{ marginTop: "70px", marginLeft:"10px",width:"1400px", marginRight:0 ,background: COLORS.primary, color: COLORS.text }}>

//           {/* Header */}
//           <div className="modal-header border-0">
//             <h5 className="modal-title" style={{ color: COLORS.text, fontFamily: "Poppins" }}>
//               Add New User
//             </h5>
//             <button type="button" className="btn-close" onClick={() => { clearForm(); onClose(); }}></button>
//           </div>

//           <form onSubmit={handleSubmit}>

//             {/* Row 1: Full Name & Email */}
//             <div className="row" style={{ margin: "0% 2%" }}>
//               <div className="col-sm-6">
//                 <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
//                   Full Name <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="Enter full name"
//                   style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
//                   value={fullName}
//                   onChange={(e) => setFullName(e.target.value)}
//                 />
//               </div>
//               <div className="col-sm-6">
//                 <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
//                   Email ID <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <input
//                   type="email"
//                   className="form-control form-control-sm"
//                   placeholder="Enter email ID"
//                   style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
//                   value={officialEmail}
//                   onChange={(e) => setOfficialEmail(e.target.value)}
//                 />
//               </div>
//             </div>

//             {/* Row 2: Mobile & Address */}
//             <div className="row" style={{ margin: "1% 2%" }}>
//               <div className="col-sm-6">
//                 <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
//                   Mobile Number <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="Enter 10-digit mobile number"
//                   style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
//                   value={mobileNumber}
//                   onChange={(e) => setMobileNumber(e.target.value)}
//                 />
//               </div>
//               <div className="col-sm-6">
//                 <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
//                   Address <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="Enter address"
//                   style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
//                   value={address}
//                   onChange={(e) => setAddress(e.target.value)}
//                 />
//               </div>
//             </div>

//             {/* Row 3: Department & Designation */}
//             <div className="row" style={{ margin: "1% 2%" }}>
//               <div className="col-sm-6">
//                 <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
//                   Department <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="Enter department"
//                   style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
//                   value={department}
//                   onChange={(e) => setDepartment(e.target.value)}
//                 />
//               </div>
//               <div className="col-sm-6">
//                 <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
//                   Designation <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="Enter designation"
//                   style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
//                   value={designation}
//                   onChange={(e) => setDesignation(e.target.value)}
//                 />
//               </div>
//             </div>

//             {/* Row 4: Category & Panel */}
//             <div className="row" style={{ margin: "1% 2%" }}>
//               <div className="col-sm-6">
//                 <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
//                   Category <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <select
//                   className="form-select form-select-sm"
//                   style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
//                   value={category}
//                   onChange={(e) => setCategory(e.target.value)}
//                 >
//                   <option value="" disabled>Select Category</option>
//                   {categoryOptions.map((opt) => (
//                     <option key={opt} value={opt}>{opt}</option>
//                   ))}
//                 </select>
//               </div>
//               <div className="col-sm-6">
//                 <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
//                   Panel <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <select
//                   className="form-select form-select-sm"
//                   style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
//                   value={panel}
//                   onChange={(e) => setPanel(e.target.value)}
//                 >
//                   <option value="" disabled>Select Panel</option>
//                   {panelOptions.map((opt) => (
//                     <option key={opt} value={opt}>{opt}</option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* Row 5: Functional Area & Additional Functional Area */}
//             <div className="row" style={{ margin: "1% 2%" }}>
//               <div className="col-sm-6">
//                 <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
//                   Functional Area
//                 </label>
//                 <select
//                   className="form-select form-select-sm"
//                   style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
//                   value={functionalArea}
//                   onChange={(e) => setFunctionalArea(e.target.value)}
//                 >
//                   <option value="">Select Functional Area</option>
//                   {functionalAreaOptions.map((opt) => (
//                     <option key={opt} value={opt}>{opt}</option>
//                   ))}
//                 </select>
//               </div>
//               <div className="col-sm-6">
//                 <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
//                   Additional Functional Area
//                   <span style={{ fontSize: "10px", marginLeft: "4px" }}>(comma separated)</span>
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="e.g. DevOps, Data Science"
//                   style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
//                   value={additionalFunctionalArea}
//                   onChange={(e) => setAdditionalFunctionalArea(e.target.value)}
//                 />
//               </div>
//             </div>

//             {/* Row 6: Skills & Additional Skills */}
//             <div className="row" style={{ margin: "1% 2%" }}>
//               <div className="col-sm-6">
//                 <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
//                   Skills{" "}
//                   {category === "Technical" && <span style={{ color: "red" }}>*</span>}
//                   <span style={{ fontSize: "10px", marginLeft: "4px" }}>(comma separated)</span>
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="e.g. React, Python, Java"
//                   style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
//                   value={skills}
//                   onChange={(e) => setSkills(e.target.value)}
//                 />
//               </div>
//               <div className="col-sm-6">
//                 <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
//                   Additional Skills
//                   <span style={{ fontSize: "10px", marginLeft: "4px" }}>(comma separated)</span>
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="e.g. Docker, AWS"
//                   style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
//                   value={additionalSkills}
//                   onChange={(e) => setAdditionalSkills(e.target.value)}
//                 />
//               </div>
//             </div>

//             {/* Row 7: Activation */}
//             <div className="row" style={{ margin: "1% 2% 2% 2%" }}>
//               <div className="col-sm-6">
//                 <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
//                   Activation Status
//                 </label>
//                 <select
//                   className="form-select form-select-sm"
//                   style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
//                   value={activation.toString()}
//                   onChange={(e) => setActivation(e.target.value === "true")}
//                 >
//                   <option value="false">Inactive</option>
//                   {/* <option value="true">Active</option> */}
//                 </select>
//               </div>
//             </div>

//             {/* Footer Buttons */}
//             <div className="modal-footer d-flex flex-row justify-content-end border-0">
//               <button
//                 type="button"
//                 className="btn btn-sm rounded-2 fw-medium"
//                 onClick={() => { clearForm(); onClose(); }}
//                 style={{
//                   color: COLORS.button,
//                   width: "120px",
//                   border: `1px solid ${COLORS.button}`,
//                   marginRight: "10px",
//                 }}
//               >
//                 Clear
//               </button>
//               <button
//                 type="submit"
//                 className="btn btn-sm rounded-2 fw-medium"
//                 style={{ background: COLORS.button, color: COLORS.background, width: "120px" }}
//                 disabled={isSubmitting}
//               >
//                 {isSubmitting ? (
//                   <div className="spinner-border spinner-border-sm text-light" role="status">
//                     <span className="visually-hidden">Loading...</span>
//                   </div>
//                 ) : (
//                   "Submit"
//                 )}
//               </button>
//             </div>

//           </form>
//         </div>
//       </div>
//     </div>
//     </>
//     )}
//   </>
//   );
// };

// export default InterviewerJoining;










































































import React, { useState, useEffect } from "react";
import createInstance from "../../../api/axiosinstance.js";
import { toast } from "react-toastify";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

const InterviewerJoining = ({  isOpen, onClose, fetchTableData, editData = null, purpose = "Add" }) => {
  const aiDishaApi = createInstance("DISHA");
  const { COLORS } = useThemeMode();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Form fields
  const [fullName, setFullName] = useState("");
  const [officialEmail, setOfficialEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [address, setAddress] = useState("");
  const [department, setDepartment] = useState("");
  const [designation, setDesignation] = useState("");
  const [skills, setSkills] = useState([]);
  const [additionalSkills, setAdditionalSkills] = useState("");
  const [functionalArea, setFunctionalArea] = useState("");
  const [additionalFunctionalArea, setAdditionalFunctionalArea] = useState("");
  const [category, setCategory] = useState("");
  const [panel, setPanel] = useState("");
  const [activation, setActivation] = useState(false);
  const [status, setStatus] = useState("");

  // API-driven dropdown data
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [skillOptions, setSkillOptions] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [loadingSkills, setLoadingSkills] = useState(false);

  // const isEditMode = !!editData;
  const isEditMode = purpose === "Edit";
  const isViewMode = purpose === "View";
  const organizationId = window.sessionStorage.getItem("organizationId") || "";

  const categoryOptions = ["OrgAdmin", "Interviewer", "HR"];
  const panelOptions = ["Technical", "HR", "Managerial"];
  const functionalAreaOptions = [
"Front-end development",
"Back-end development",
"Mobile App Development",
"Data Engineering",
"DevOps Engineering",
"Testing",
"Project Management",
"Business Analysis",
"Recruitment",
"Performance Management",
"Cybersecurity",
"Cloud Computing",
"Artificial Intelligence & Machine Learning",
"Database Management",
"Customer Relationship Management (CRM)",
"Brand Management",
"HR Analytics",
  ];
  const statusOptions = ["Active", "Inactive"];

  // Fetch departments from API
  useEffect(() => {
    if (!isOpen) return;
    const fetchDepartments = async () => {
      setLoadingDepartments(true);
      try {
        const response = await aiDishaApi.get(
          `/org-get-departments?organization_id=${organizationId}`
        );
        // Adjust based on your actual response shape
        const data = response.data?.departments || response.data || [];
        setDepartmentOptions(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching departments:", error);
        toast.error("Failed to load departments");
      } finally {
        setLoadingDepartments(false);
      }
    };
    fetchDepartments();
  }, [isOpen, organizationId]);

  // Fetch active skills from API
  useEffect(() => {
    if (!isOpen) return;
    const fetchSkills = async () => {
      setLoadingSkills(true);
      try {
        const response = await aiDishaApi.get("/skills-show/active");
        // Adjust based on your actual response shape
        const data = response.data?.skills || response.data || [];
        setSkillOptions(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching skills:", error);
        toast.error("Failed to load skills");
      } finally {
        setLoadingSkills(false);
      }
    };
    fetchSkills();
  }, [isOpen]);

  // Pre-fill form when in edit mode
  useEffect(() => {
    // if (isEditMode && editData) {
    if ((isEditMode || isViewMode) && editData){
      setFullName(editData.full_name || "");
      setOfficialEmail(editData.official_email_id || "");
      setMobileNumber(editData.mobile_number || "");
      setAddress(editData.address || "");
      setDepartment(editData.department || "");
      setDesignation(editData.designation || "");
      setSkills(Array.isArray(editData.skills) ? editData.skills : []);
      setAdditionalSkills(editData.additional_skills || "");
      // setAdditionalSkills(
      //   Array.isArray(editData.additional_skills)
      //     ? editData.additional_skills.join(", ")
      //     : editData.additional_skills || ""
      // );
      setFunctionalArea(editData.functional_area || "");
      setAdditionalFunctionalArea(editData.additional_functional_area || "");
      setCategory(editData.category || "");
      setPanel(editData.panel || "");
      setStatus(editData.status || "");
      setActivation(editData.activation || false);
    } else {
      clearForm();
    }
  }, [editData, isEditMode,isViewMode, isOpen]);

  const clearForm = () => {
    setFullName("");
    setOfficialEmail("");
    setMobileNumber("");
    setAddress("");
    setDepartment("");
    setDesignation("");
    setSkills([]);
    setAdditionalSkills("");
    setFunctionalArea("");
    setAdditionalFunctionalArea("");
    setCategory("");
    setPanel("");
    setActivation(false);
    setStatus("");
  };

  // Multi-select toggle for skills
  const toggleSkill = (skill) => {
    setSkills((prev) =>
      prev.includes(skill) ? prev.filter((s) => s !== skill) : [...prev, skill]
    );
  };

  const validateForm = () => {
    if (!fullName.trim()) { toast.error("Full name cannot be empty"); return false; }
    if (fullName.trim().length < 3 || fullName.trim().length > 20) {
      toast.error("Full name must be between 3 and 20 characters"); return false;
    }
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!officialEmail.trim() || !emailRegex.test(officialEmail)) {
      toast.error("Enter a valid email"); return false;
    }
    const phoneRegex = /^[0-9]{10}$/;
    if (!mobileNumber.trim() || !phoneRegex.test(mobileNumber)) {
      toast.error("Enter a valid 10-digit mobile number"); return false;
    }
    if (!address.trim()) { toast.error("Address cannot be empty"); return false; }
    if (!department.trim()) { toast.error("Department cannot be empty"); return false; }
    if (!designation.trim()) { toast.error("Designation cannot be empty"); return false; }
    if (!category) { toast.error("Category cannot be empty"); return false; }
    if (!panel) { toast.error("Panel cannot be empty"); return false; }
    if (category === "Technical" && skills.length === 0) {
      toast.error("Skills are required for Technical category"); return false;
    }
    return true;
  };

  // CREATE handler
  const handleCreate = async () => {
    const response = await aiDishaApi.post(
      "/org-user-Register",
      {
        organization_id: organizationId,
        full_name: fullName,
        official_email_id: officialEmail,
        mobile_number: mobileNumber,
        address: address,
        department: department,
        designation: designation,
        skills: skills,
        additional_skills: additionalSkills || "",
        additional_functional_area: additionalFunctionalArea || "",
        // additional_skills: additionalSkills
        //   ? additionalSkills.split(",").map((s) => s.trim()).filter(Boolean)
        //   : [],
        // additional_functional_area: additionalFunctionalArea
        //   ? additionalFunctionalArea.split(",").map((s) => s.trim()).filter(Boolean)
        //   : [],
        activation: activation,
      },
      {
        params: {
          functional_area: functionalArea || undefined,
          category: category,
          panel: panel || undefined,
        },
      }
    );
    if (response.status === 200) {
      toast.success(response.data.message || "User created successfully and activation mail sent!");
    }
  };

  console.log("TYPE:", typeof additionalSkills);
console.log("VALUE:", additionalSkills);

  // UPDATE handler — calls the PUT endpoint from the provided API
  const handleUpdate = async () => {
    const panelistId = editData.panelist_id;

    const body = {
      full_name: fullName,
      official_email_id: officialEmail,
      mobile_number: mobileNumber,
      address: address,
      department: department,
      designation: designation,
      skills: skills,
      additional_skills: Array.isArray(additionalSkills)
    ? additionalSkills.join(", ")
    : additionalSkills || "",

  additional_functional_area: Array.isArray(additionalFunctionalArea)
    ? additionalFunctionalArea.join(", ")
    : additionalFunctionalArea || "",
      // additional_skills: additionalSkills || "",
      // additional_functional_area: additionalFunctionalArea || "",
      status: status || undefined,
    };

    console.log("FINAL TYPE:", typeof body.additional_skills);
console.log("FINAL VALUE:", body.additional_skills);

    const response = await aiDishaApi.put(
      `/org-user-update-admin/${panelistId}`,
      body,
      {
        params: {
          functional_area: functionalArea || undefined,
          category: category,
          panel: panel || undefined,
        },
      }
    );
    if (response.status === 200) {
      toast.success(response.data.message || "User updated successfully!");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsSubmitting(true);
    try {
      if (isEditMode) {
        await handleUpdate();
      } else {
        await handleCreate();
      }
      clearForm();
      if (onClose) onClose();
      if (fetchTableData) fetchTableData();
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error(error.response?.data?.detail || "Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  const inputStyle = {
    background: COLORS.background,
    color: COLORS.text,
    border: "none",
  };

  const labelStyle = {
    fontFamily: "Poppins",
    fontSize: "12px",
    color: COLORS.text,
  };

  const rowStyle = { margin: "1% 2%" };

  return (
    <>
      {isOpen && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div
              className="modal-content"
              style={{
                marginTop: "70px",
                marginLeft: "10px",
                width: "1400px",
                marginRight: 0,
                background: COLORS.primary,
                color: COLORS.text,
              }}
            >
              {/* Header */}
              <div className="modal-header border-0">
                <h5
                  className="modal-title"
                  style={{ color: COLORS.text, fontFamily: "Poppins" }}
                >
                    {purpose === "Add" ? "Add New User" : purpose === "Edit" ? "Edit User" : "View User"}

                  {/* {isEditMode ? "Edit User" : "Add New User"} */}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => { clearForm(); onClose(); }}
                ></button>
              </div>

              <form onSubmit={handleSubmit}>

                {/* Row 1: Full Name & Email */}
                <div className="row" style={{ margin: "0% 2%" }}>
                  <div className="col-sm-6">
                    <label style={labelStyle}>
                      Full Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Enter full name"
                      style={inputStyle}
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                     disabled={isViewMode}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label style={labelStyle}>
                      Email ID <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control form-control-sm"
                      placeholder="Enter email ID"
                      style={inputStyle}
                      value={officialEmail}
                      onChange={(e) => setOfficialEmail(e.target.value)}
                      disabled={isViewMode}
                    />
                  </div>
                </div>

                {/* Row 2: Mobile & Address */}
                <div className="row" style={rowStyle}>
                  <div className="col-sm-6">
                    <label style={labelStyle}>
                      Mobile Number <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Enter 10-digit mobile number"
                      style={inputStyle}
                      value={mobileNumber}
                      onChange={(e) => setMobileNumber(e.target.value)}
                      disabled={isViewMode}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label style={labelStyle}>
                      Address <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Enter address"
                      style={inputStyle}
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      disabled={isViewMode}
                    />
                  </div>
                </div>

                {/* Row 3: Department (API dropdown) & Designation */}
                <div className="row" style={rowStyle}>
                  <div className="col-sm-6">
                    <label style={labelStyle}>
                      Department <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-select form-select-sm"
                      style={inputStyle}
                      value={department}
                      onChange={(e) => setDepartment(e.target.value)}
                      disabled={loadingDepartments}
                      disabled={isViewMode}
                    >
                      <option value="">
                        {loadingDepartments ? "Loading departments..." : "Select Department"}
                      </option>
                      {departmentOptions.map((dept, idx) => {
                        // Support both string arrays and object arrays {name, id}
                        const label = typeof dept === "string" ? dept : dept.name || dept.department_name;
                        const value = typeof dept === "string" ? dept : dept.name || dept.department_name;
                        return (
                          <option key={idx} value={value}>
                            {label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-sm-6">
                    <label style={labelStyle}>
                      Designation <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Enter designation"
                      style={inputStyle}
                      value={designation}
                      onChange={(e) => setDesignation(e.target.value)}
                      disabled={isViewMode}
                    />
                  </div>
                </div>

                {/* Row 4: Category & Panel */}
                <div className="row" style={rowStyle}>
                  <div className="col-sm-6">
                    <label style={labelStyle}>
                      Category <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-select form-select-sm"
                      style={inputStyle}
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                      disabled={isViewMode}
                    >
                      <option value="" disabled>Select Category</option>
                      {categoryOptions.map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-6">
                    <label style={labelStyle}>
                      Panel <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-select form-select-sm"
                      style={inputStyle}
                      value={panel}
                      onChange={(e) => setPanel(e.target.value)}
                      disabled={isViewMode}
                    >
                      <option value="" disabled>Select Panel</option>
                      {panelOptions.map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Row 5: Functional Area & Additional Functional Area */}
                <div className="row" style={rowStyle}>
                  <div className="col-sm-6">
                    <label style={labelStyle}>Functional Area</label>
                    <select
                      className="form-select form-select-sm"
                      style={inputStyle}
                      value={functionalArea}
                      onChange={(e) => setFunctionalArea(e.target.value)}
                      disabled={isViewMode}
                    >
                      <option value="">Select Functional Area</option>
                      {functionalAreaOptions.map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-6">
                    <label style={labelStyle}>
                      Additional Functional Area
                      <span style={{ fontSize: "10px", marginLeft: "4px" }}>(comma separated)</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="e.g. DevOps, Data Science"
                      style={inputStyle}
                      value={additionalFunctionalArea}
                      onChange={(e) => setAdditionalFunctionalArea(e.target.value)}
                      disabled={isViewMode}
                    />
                  </div>
                </div>

                {/* Row 6: Skills (API multi-select) & Additional Skills */}
                <div className="row" style={rowStyle}>
                  <div className="col-sm-6">
                    <label style={labelStyle}>
                      Skills{" "}
                      {category === "Technical" && <span style={{ color: "red" }}>*</span>}
                    </label>
                    <select
                      className="form-select form-select-sm"
                      style={{ ...inputStyle, height: "auto", minHeight: "80px" }}
                      multiple
                      value={skills}
                      onChange={(e) => {
                        const selected = Array.from(e.target.selectedOptions).map((o) => o.value);
                        setSkills(selected);
                      }}
                      disabled={loadingSkills || isViewMode}
                    >
                      {loadingSkills ? (
                        <option disabled>Loading skills...</option>
                      ) : (
                        skillOptions.map((skill, idx) => {
                          // Support both string arrays and object arrays
                          const label = typeof skill === "string" ? skill : skill.skill_name || skill.name;
                          const value = typeof skill === "string" ? skill : skill.skill_name || skill.name;
                          return (
                            <option key={idx} value={value}>
                              {label}
                            </option>
                          );
                        })
                      )}
                    </select>
                    <small style={{ fontSize: "10px", color: COLORS.text, opacity: 0.6 }}>
                      Hold Ctrl / Cmd to select multiple skills
                    </small>
                    {/* Selected skills as removable tags */}
                    {skills.length > 0 && (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", marginTop: "6px" }}>
                        {skills.map((skill) => (
                          <span
                            key={skill}
                            style={{
                              background: COLORS.button,
                              color: COLORS.background,
                              borderRadius: "4px",
                              padding: "2px 8px",
                              fontSize: "11px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                            onClick={() => toggleSkill(skill)}
                          >
                            {skill} <span style={{ fontWeight: "bold" }}>×</span>
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <label style={labelStyle}>
                      Additional Skills
                      <span style={{ fontSize: "10px", marginLeft: "4px" }}>(comma separated)</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="e.g. Docker, AWS"
                      style={inputStyle}
                      value={additionalSkills}
                      onChange={(e) => setAdditionalSkills(e.target.value)}
                      disabled={isViewMode}
                    />
                  </div>
                </div>

                {/* Row 7: Activation + Status (edit only) */}
                <div className="row" style={{ margin: "1% 2% 2% 2%" }}>
                  {!isEditMode && (
                    <div className="col-sm-6">
                      <label style={labelStyle}>Activation Status</label>
                      <select
                        className="form-select form-select-sm"
                        style={inputStyle}
                        value={activation.toString()}
                        onChange={(e) => setActivation(e.target.value === "true")}
                        disabled={isViewMode}
                      >
                        <option value="false">Inactive</option>
                        <option value="true">Active</option>
                      </select>
                    </div>
                  )}
                  {isEditMode && (
                    <div className="col-sm-6">
                      <label style={labelStyle}>Status</label>
                      <select
                        className="form-select form-select-sm"
                        style={inputStyle}
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        disabled={isViewMode}
                      >
                        <option value="">Select Status</option>
                        {statusOptions.map((opt) => (
                          <option key={opt} value={opt}>{opt}</option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>

                {/* Footer Buttons */}
                <div className="modal-footer d-flex flex-row justify-content-end border-0">
                  <button
                    type="button"
                    className="btn btn-sm rounded-2 fw-medium"
                    onClick={() => { clearForm(); onClose(); }}
                    style={{
                      color: COLORS.button,
                      width: "120px",
                      border: `1px solid ${COLORS.button}`,
                      marginRight: "10px",
                    }}
                  >
                    Clear
                  </button>

                  {!isViewMode && (
                  <button
                    type="submit"
                    className="btn btn-sm rounded-2 fw-medium"
                    style={{
                      background: COLORS.button,
                      color: COLORS.background,
                      width: "120px",
                    }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <div className="spinner-border spinner-border-sm text-light" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : isEditMode ? (
                      "Update"
                    ) : (
                      "Submit"
                    )}
                  </button>
                  )}
                </div>

              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InterviewerJoining;